import { Fragment } from "react";

import { twJoin, twMerge } from "tailwind-merge";

import { Cell } from "./cell";

export const Header = () => {
  const cls = twJoin("border-none");
  return (
    <Fragment>
      <Cell className={twMerge(cls, "justify-start px-0")}>#</Cell>
      <Cell className={twMerge(cls, "justify-start")}>Validator</Cell>
      <Cell className={cls}>Voting Power</Cell>
      <Cell className={cls}>24h Changes</Cell>
      <Cell className={cls}>Commission</Cell>
      <Cell className={cls}>Actions</Cell>
    </Fragment>
  );
};
